
import { Vue, Component, Prop, Model } from "vue-property-decorator";

interface HTMLChangeEvent extends Event {
  target: HTMLInputElement & EventTarget;
}
@Component
export default class Checkbox extends Vue {
  @Prop({type: String, required: true}) readonly name!: string;
  @Prop({type: String, required: true}) readonly id!: string;
  @Model("toggle", {type: Boolean}) readonly selected!: boolean;

  updateVal(event: HTMLChangeEvent): void {
    const rawValue = event.target.checked;
    this.$emit("toggle", rawValue);
  }
}
